






import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { mapActions } from 'vuex';
import Presentational from './presentational.vue';
import { job7th } from '../../../module/jobList';
import { ProfileModel } from '@/model/charactersheets';

@Component({
  components: { Presentational },
})
export default class JobSelectModalContainer extends Vue {
  private jobList = job7th;

  @Action('Charactersheets/updateProfile')
  private updateProfile!: (payload) => void;
  @Action('Charactersheets/addSkill')
  private addSkill!: (payload) => void;
  @Action('Charactersheets/updateJobPointFormula')
  private updateJobPointFormula!: (payload) => void;

  @Getter('Charactersheets/getProfile')
  private profiles!: ProfileModel;

  public addSkills(payload) {
    payload.skills.forEach(item => {
      this.addSkill({
        label: item.label,
        initial: item.initial,
        interestpoint: 0,
        jobpoint: 0,
        otherpoint: 0,
        totalpoint: item.initial,
      });
    });
    this.addSkill({
      label: payload.confidence.label,
      initial: payload.confidence.initial,
      interestpoint: payload.confidence.interestpoint,
      jobpoint: payload.confidence.jobpoint,
      otherpoint: 0,
      totalpoint: payload.confidence.initial + payload.confidence.interestpoint + payload.confidence.jobpoint,
    });
    this.updateJobPointFormula(payload.jobPointFormula);
    this.updateProfile({
      name: this.profiles.name,
      job: payload.label,
      sex: this.profiles.sex,
      age: this.profiles.age,
    });
  }
}
